///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/filter-interactive.ts"/>


module Meevo.Components.Controls.SmartMover {
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export class TerminatedFilter extends InteractiveFilter implements IInteractiveFilter {
        public readonly templateName: FilterTemplateNames;
        public readonly values: { hideTerminated: boolean};
        public readonly labels: { hideTerminatedLabel: string; };
        public readonly disabled: boolean;
        public model: any;
        public propertyName: any;

        constructor(labels: { hideTerminatedLabel: string }, public dataTemplate: IDataTemplate = null, private showSelectedTerminated = false, model?: any, propertyName?: string) {
            super({labels}, dataTemplate);

            this.templateName = 'terminated';
            this.values = {
                hideTerminated: true
            };
            if (dataTemplate) {
                this.disabled = dataTemplate.disabled;
            }

            if (model && propertyName) {
                this.model = model;
                this.propertyName = propertyName;
                if (model[propertyName] == null) {
                    model[propertyName] = this.values.hideTerminated;
                }
                else {
                    this.values.hideTerminated = model[propertyName];
                }
            }
        }

        onFilterChange() {
            if (this.model && this.propertyName) {
                this.model[this.propertyName] = this.values.hideTerminated;
            }
            this.emit('change');
        }

        filter(rows: ISmartMoverModel<any>[]): ISmartMoverModel<any>[] {
            return rows
                .filter(row => (!row.get('isTerminated')
                            || (this.showSelectedTerminated && row.selected)
                            || (!this.values.hideTerminated && row.get('isTerminated'))))
        }
    }
}